import winston from 'winston';
import DatadogWinston from 'datadog-winston';

const dataDogApiKey = process.env.NEXT_PUBLIC_DATADOG_API_KEY;
const dataDogService = process.env.NEXT_PUBLIC_DATADOG_APP_SERVICE;

const logger = winston.createLogger();

logger.add(new winston.transports.Console());
logger.add(
  new DatadogWinston({
    apiKey: dataDogApiKey,
    hostname: 'serverless functions',
    service: dataDogService,
    ddsource: 'server'
  })
);

const apiLogger = winston.createLogger();

apiLogger.add(new winston.transports.Console());
apiLogger.add(
  new DatadogWinston({
    apiKey: dataDogApiKey,
    hostname: 'nextjs-api',
    service: dataDogService,
    ddsource: 'nextjs-api'
  })
);

const authLogger = winston.createLogger();

authLogger.add(new winston.transports.Console());
authLogger.add(
  new DatadogWinston({
    apiKey: dataDogApiKey,
    hostname: 'nextjs-auth',
    service: dataDogService,
    ddsource: 'nextjs-auth'
  })
);

const dynamicLandersLogger = winston.createLogger();

dynamicLandersLogger.add(new winston.transports.Console());
dynamicLandersLogger.add(
  new DatadogWinston({
    apiKey: dataDogApiKey,
    hostname: 'nextjs-dynamic-landers',
    service: dataDogService,
    ddsource: 'nextjs-dynamic-landers'
  })
);

const performanceLogger = winston.createLogger();

performanceLogger.add(new winston.transports.Console());
performanceLogger.add(
  new DatadogWinston({
    apiKey: dataDogApiKey,
    hostname: 'performance-audit',
    service: dataDogService,
    ddsource: 'performance-audit'
  })
);

export const getDataDogLogger = () => ({
  logger,
  apiLogger,
  authLogger,
  dynamicLandersLogger,
  performanceLogger
});
